import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, Award } from "lucide-react";

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { dateStyle: "medium" }) : "—");
const LETTER = { sent: "Mastery letter sent", failed: "Mastery letter failed", pending: "Mastery letter sending" };

export default function MasteryAdmin({ http, withRefresh }) {
  const [list, setList] = useState(null);
  useEffect(() => {
    withRefresh(() => http.get("/admin/mastery"))
      .then(({ data }) => setList(Array.isArray(data) ? data : []))
      .catch(() => toast.error("Could not load the honour roll."));
  }, [http, withRefresh]);
  const rows = list ?? [];
  return (
    <div data-testid="mastery-admin" className="mt-10">
      <div className="border border-[#D9B47A]/20 bg-[#0D0908] p-6 flex items-center gap-5">
        <Award className="w-8 h-8 text-[#D9B47A] shrink-0" />
        <div>
          <p data-testid="mastery-count" className="font-display text-4xl text-[#D9B47A]">{rows.length}</p>
          <p className="font-tt-mono text-[12px] uppercase tracking-[0.2em] text-[#A8998C] mt-1">Initiates who have walked all 13 gates</p>
        </div>
      </div>
      {list !== null && rows.length === 0 && <p data-testid="mastery-empty" className="mt-12 font-display italic text-2xl text-[#A8998C]">No one has completed all 13 gates yet. They will appear here the moment they do.</p>}
      <ul className="mt-6 border-t border-[#D9B47A]/15">
        {rows.map((r) => (
          <li key={r.id} data-testid={`mastery-row-${r.id}`} className="grid grid-cols-12 gap-3 items-center py-5 border-b border-[#D9B47A]/15 px-2">
            <div className="col-span-12 sm:col-span-5 min-w-0">
              <p className="font-display text-xl truncate">{r.name || "—"}</p>
              <p className="text-sm text-[#CFC2B6] truncate">{r.email}</p>
            </div>
            <div className="col-span-12 sm:col-span-3 font-tt-mono text-[12px] text-[#A8998C]">
              Mastered {fmt(r.mastered_at)}
              <span className="block">{LETTER[r.letter] ?? ""}</span>
            </div>
            <div className="col-span-12 sm:col-span-4 flex sm:justify-end gap-2 flex-wrap">
              <a href={r.certificate_url} target="_blank" rel="noreferrer" data-testid={`mastery-cert-${r.id}`} className="inline-flex items-center gap-2 rounded-full border border-[#D9B47A]/50 px-4 py-2 text-sm hover:bg-[#D9B47A] hover:text-[#0A0706] transition-colors"><Award className="w-4 h-4" /> Certificate</a>
              <a href={`mailto:${r.email}?subject=${encodeURIComponent("From Goddess Ariel — on your mastery")}`} data-testid={`mastery-email-${r.id}`} className="inline-flex items-center gap-2 rounded-full border border-[#C2414F]/60 px-4 py-2 text-sm hover:bg-[#C2414F] transition-colors"><Mail className="w-4 h-4" /> Write to them</a>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
